import React from 'react';
import Input from './Input';
import {
  maskCpf,
  maskCnpj,
  maskPhone,
  maskCep,
  maskCard,
  maskExpiry,
} from '../../utils/maskHelpers';

const MASKS = {
  cpf: maskCpf,
  cnpj: maskCnpj,
  phone: maskPhone,
  cep: maskCep,
  card: maskCard,
  expiry: maskExpiry,
};
const IDENTITY = (v) => v;

// Wrapper sobre Input que aplica mask em onChange. `value` recebe o
// valor mascarado pro display; use `unmask()` antes de enviar pro backend
// se precisar dos dígitos puros.
const MaskedInput = ({ mask, value, onChange, ...rest }) => {
  const handleChange = (e) => {
    const fn = MASKS[mask] || IDENTITY;
    const masked = fn(e.target.value);
    onChange?.({ ...e, target: { ...e.target, value: masked } });
  };

  return <Input {...rest} value={value ?? ''} onChange={handleChange} inputMode="numeric" />;
};

export default MaskedInput;
